import React from 'react';
import { TextArea } from 'semantic-ui-react';
import FieldWrapper from './fieldWrapper';

class TextAreaField extends React.Component {

    render() {
        const { onChange, value, placeholder, label, validation, error, errorMessage, onBlur, inputSub, popup } = this.props;

        return (
            <FieldWrapper
                label={label}
                validation={validation}
                error={error}
                errorMessage={errorMessage}
                onBlur={onBlur}
                inputSub={inputSub}
                popup={popup}
                value={value}
            >
                <TextArea
                    onChange={onChange}
                    value={value}
                    placeholder={placeholder}
                />
            </FieldWrapper>
        );
    }
}

export default TextAreaField;